import { useId } from 'react';
import { Switch, Text } from '@radix-ui/themes';

import styles from '../NotificationPreferences.module.css';

export default function NotificationItem({
  name,
  label,
  description,
  checked,
  onChange,
  onClick,
  isLast = false,
}) {
  const labelId = useId();
  const descriptionId = useId();

  return (
    <div
      className={`${styles.item} ${isLast ? styles.lastItem : ''}`}
      onClick={() => onClick(name)}
    >
      <div className={styles.info}>
        <Text id={labelId} size="2" weight="medium" className={styles.label}>
          {label}
        </Text>
        <Text id={descriptionId} size="2" className={styles.labelDescription}>
          {description}
        </Text>
      </div>
      <Switch
        name={name}
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
        checked={checked}
        onCheckedChange={checked =>
          onChange({
            target: { name, checked },
          })
        }
        className={styles.checkbox}
        size="2"
      />
    </div>
  );
}
